import domains from './domains';
import aliases from './aliases';
import mailboxes from './mailboxes';

export default {
    namespaced: true,
    modules: {
        domains,
        aliases,
        mailboxes,
    }
}